module.exports = "<div id='spacerxsm'></div>\r\n<div class='hdr' width=95%>\r\n   <div class='row' width=95% ><span class='hdrTxt' title='Please contact GIS Vendor Relations for any questions related to CRIM'>Help</span></div>\r\n</div>\r\n<div id='spacersm'></div>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/loginHeader/loginHeader.component.html
// module id = ./src/app/loginHeader/loginHeader.component.html
// module chunks = app